export default {
  title: 'New Asset',
  title_edit: 'Editing Asset',
  bulkRegister: 'Bulk create',
  name: 'Name*',
  placeType: 'Place type',
  place: 'Place',
  type: 'Type'
}
